import React from "react";
import { useSearchParams } from "react-router-dom";
import { useStudentsLists } from "../../../hooks/students/useStudentsLists.hooks";
import { useStudentListFilters } from "../../../hooks/filterHooks/useStudentFilterHooks";
import { StudentList } from "./StudentsList";

export const ActiveStudentList = () => {
  const { filters } = useStudentListFilters("ACTIVE_STUDENT");
  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "") || 1;
  const { page: _page, ...appliedFilters } = filters || {};

  const { isLoading: isStudentsListLoading, data: studentsList } =
    useStudentsLists({
      page,
      filters: {
        ...appliedFilters,
      },
    });

  return (
    <StudentList
      isStudentsListLoading={isStudentsListLoading}
      studentsList={studentsList}
      studentListNameSpace="ACTIVE_STUDENT"
    />
  );
};
